export const enum LIST_ACTIONS {
  // Module name
  MODULE_LIST = "List",
  // Actions
  GET_LIST = "getList",
}
